import { SvgProps } from "../../utils/types";

export default function VideoIcon({ stroke }: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
        >
            <path
                d="M10.745 8.49992L14.6666 5.38881V11.6111L10.745 8.49992ZM10.745 8.49992V5.38881C10.745 4.5297 10.0427 3.83325 9.17639 3.83325H2.90188C2.03555 3.83325 1.33325 4.5297 1.33325 5.38881V11.6111C1.33325 12.4701 2.03555 13.1666 2.90188 13.1666H9.17639C10.0427 13.1666 10.745 12.4701 10.745 11.6111V8.49992Z"
                stroke={stroke || "#5A5F6A"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
